import axios from "axios";
import { BACKEND_URL } from "../constants/constants";
import { useHistory } from "react-router-dom";

const api = axios.create({
  baseURL: BACKEND_URL,
});

// Add a request interceptor
api.interceptors.request.use(
  (config) => {
    config.headers["Access-Control-Allow-Origin"] = "*";
    config.headers['Content-Type'] = 'application/json';
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
// api.interceptors.response.use(
//   function (response) {
//     return response;
//   },
//   function (error) {
//     if (error?.response?.data?.message === "Invalid token!") {
//       console.log('Interceptor Error: ', error?.response?.data);
//       localStorage.removeItem("userToken");
//       window.location.reload();
//       const history = useHistory();
//       history.replace("/");
//     }
//     return Promise.reject(error);
//   }
// );

export default api;
